<div class="login-main">
    <img class="close-icon cursor-pointer" (click)="closePopUp()" src="assets/icons/close_black_round.png">
    <br><br>
    <div class="col-lg-12 content-section">
        <span class="tab-set cursor-pointer radius-left" [ngClass]="{'active-tab':activeTab==='exist'}"
        (click)="setActive('exist')">
        <span class="left-buttons text-center ">
          <a class="tab-btn-text">Existing Investor</a>
        </span>
      </span>
      <span class="tab-set cursor-pointer radius-right" [ngClass]="{'active-tab':activeTab==='new'}"
        (click)="setActive('new')">
        <span class="left-buttons text-center ">
          <a class="tab-btn-text">New Investor</a>
        </span>
      </span>
    <div class="existing-tab-content" *ngIf="activeTab==='exist'">
      <span class="login-header">Login to invest online with ITI Mutual Fund</span>
      <form #loginForm="ngForm">
        <div class="col-lg-12 input-section">
          <label  class="lbl-text">PAN <span class="mandatory"> *</span></label><br>
          <input type="text"  [(ngModel)]="userData.pan" autocomplete="off" name="pan" class="input"  #pan="ngModel" required>
          <span class="mandatory" *ngIf="pan.invalid && pan.errors.required">PAN required</span>
      </div>
      <div class="col-lg-12 input-section input-section2">
          <label  class="lbl-text">Password <span class="mandatory"> *</span></label><br>
          <input type="password"  [(ngModel)]="userData.password" autocomplete="off" name="password" class="input"  #password="ngModel" required>
          <span class="mandatory otp-text cursor-pointer">Use OTP</span>
            <span class="mandatory" *ngIf="password.invalid && password.errors.required">Password required</span>
      </div>
      <div class="col-lg-12 row bottom-text">
        <div class="col-lg-6">
          <input type="checkbox" class="filter-check-box cursor-pointer" value="1" required> 
          <span class="filter-check-box-text"> I agree to the Terms and Conditions</span>
      </div>
      <div class="col-lg-6">
        <span class="mandatory cursor-pointer forgot-pw"> Forgot Password?</span>
      </div>
    </div>
    <div class="col-lg-12 ">
      <button type="button"  [disabled]="loginForm.form.invalid" (click)="processForm()" class="submit-button">Login</button>

    </div>
  </form>
    </div>
    <div class="new-tab-content" *ngIf="activeTab==='new'">




      <span class="login-header">Register to invest online with ITI Mutual Fund</span>
      <form #regForm="ngForm">
        <div class="col-lg-12 row ">
          <div class="col-lg-12 radio-data row">
            <div class="col-lg-6">
              <label class="form-check-label" for="radio1">
                <input type="radio" class="form-check-input" id="radio1" name="optradio" value="no" checked>&nbsp;&nbsp; I am not US/Canada person
              </label>
            </div>
            <div class="col-lg-6">
              <label class="form-check-label" for="radio2">
                <input type="radio" class="form-check-input" id="radio2" name="optradio" value="yes">&nbsp;&nbsp; I am US/Canada person
              </label>
            </div>
          </div>
          <div class="col-lg-6 input-sections">
          <label  class="lbl-text">Name as per PAN <span class="mandatory"> *</span></label><br>
          <input type="text"  [(ngModel)]="newUserData.name" autocomplete="off" name="panNew" class="input"  #panNew="ngModel" required>
          <span class="mandatory" *ngIf="panNew.invalid && panNew.errors.required">Name required</span>
      </div>
      <div class="col-lg-6 input-sections ">
          <label  class="lbl-text">Mobile <span class="mandatory"> *</span></label><br>
          <input type="number"  [(ngModel)]="newUserData.mobile" autocomplete="off" name="mobile" class="input"  #mobile="ngModel" required>
            <span class="mandatory" *ngIf="mobile.invalid && mobile.errors.required">Mobile number required</span>
      </div>
      <div class="col-lg-6 input-sections ">
        <label  class="lbl-text">Email <span class="mandatory"> *</span></label><br>
        <input type="email"  [(ngModel)]="newUserData.email" autocomplete="off" name="email" class="input"  #email="ngModel" required>
          <span class="mandatory" *ngIf="email.invalid && email.errors.required">Email required</span>
    </div>
    </div>
      <div class="col-lg-12 row bottom-text">
        <div class="col-lg-12">
          <br>
         <input type="checkbox" class="filter-check-box cursor-pointer " value="1" required> 
          <span class="filter-check-box-text"> By entering your personal details, you hereby authorise ITI Mutual Fund, 
            ITI Asset Management Ltd. and/or its authorized service providers to contact you through all mediums including E-mail, 
            SMS, Whatsapp. This will override any NDNC registration made by you
          </span>
      </div>
    </div>
    <div class="col-lg-12 ">
      <button type="button"  [disabled]="regForm.form.invalid" (click)="processRegForm()" class="submit-button">Register</button>

    </div>
  </form>
    </div>
    </div>
</div>
